export default {
	props: {

	},
	data() {
		return {
			exportConfig: [],
			exportRef: Math.random(),
			exportinit: false,
			exportSystemColumn: [{
				title: '全部',
				label: 'total',
				field: []
			}, {
				title: '自定义',
				label: 'customer',
				field: []
			}],
			exportCustomColumn: [],
			exportConbineColumn: [],
			exportForms: [],
			exportFieldType: 'total',
			exportNoticeShow: false,
			exportParam: [],
			exportType: 'current',
		}
	},
	created() {

	},
	methods: {
		onExportNoticeShow() {
			if (!this.exportinit) {
				this.createExportForm()
				this.createExportColumn()
				this.createExportAttr()
				this.exportinit = true
			}
			this.exportFieldTypeChange()
		},
		beforeExportNoticeClose(e) {
			if (e.type == 'confirm') {
				this.exportConfig.forEach((item) => {
					if (item.field == 'column') {
						this.exportParam[item.field] = item.select
					} else {
						if (!this.exportParam.searchkey) {
							this.exportParam.searchkey = {}
						}
						this.exportParam.searchkey[item.field] = item.select
					}

				})
				this.exportParam.forms = this.exportForms
				if (this.exportParam.column.length == 0) {
					this.$message.error('导出字段不能为空')
					return new Error()
				} else {
					this.exportApi()
				}
			}
		},

		createExportForm() {
			if (this.forms) {
				this.forms.forEach((item) => {
					if (item.type == 'main') {
						this.exportForms.push(item.label)
					}
				})
			}

		},
		createExportColumn() {
			let column = []

			this.tableColumn.forEach((item) => {
				this.exportSystemColumn[0].field.push(item.field)
				column.push({
					id: item.field,
					label: item.title
				})
			})
			this.exportConfig.push({
				title: '字段',
				field: 'column',
				type: 'column',
				data: column,
				select: []
			})

			this.exportConbineColumn = this.exportSystemColumn.concat(this.exportCustomColumn)
		},
		createExportAttr() {

		},
		exportFormsChange() {

		},
		exportColumnChange(e) {
			let buff = false
			this.exportFieldType = ''
			this.exportConbineColumn.forEach((item) => {
				if (window.systemMethods.arraysAreEqual(item.field, e.checklist, false)) {
					this.exportFieldType = item.label
					buff = true
				}
			})
			if (!buff) {
				this.exportFieldType = 'customer'
			}
		},
		exportFieldTypeChange() {
			let select = []
			let obj = null
			obj = this.exportConbineColumn.find((item) => {
				return item.label == this.exportFieldType
			})
			if (obj) {
				obj.field.forEach((item) => {
					select.push(item)
				})
			}
			this.exportConfig[0].select = select

		},
		exportcurrent() {
			let list = this.moduleName ? this.moduleName : this.reportName
			
			let checkData = this.$refs[list + '_list'].getCheckboxRecords()
			if (checkData.length == 0) {
				checkData = this.$refs[list + '_list'].getTableData().fullData
			}
			
			checkData.forEach((item) => {
				this.ids.push(item.id)
			})
	
		},
		exportApi() {
			this.ids = []
			let obj = {
				ids: this.ids,
				type: this.exportType,
			}
			obj = {
				...obj,
				...this.exportParam
			}
			if (obj.type == 'current') {

				this.exportcurrent()
			} else {
				this.ids = []
			}
			this.loading = true
			this.$api[this.moduleName].export(obj).then((res) => {
				this.alterexport(res)
				this.$refs[this.exportRef].exportData(res)
				this.loading = false
			}, () => {
				this.loading = false
			})
			this.ids = []
		},
		alterexport() {

		},
	},
}
